module.exports = __webpack_public_path__ + "img/couples_01_V.9a04e830.jpg";